<template>
  <section id="service-main" class="section">
    <div class="container">
      <h1 class="section-title text-center">
        Une plateforme simple pour les chercheurs d'emploi et les recruteurs
      </h1>
      <div class="row">
        <div class="col-sm-6 col-md-4">
          <div class="service-item">
            <div class="icon-wrapper">
              <i class="ti-stats-up"> </i>
            </div>
            <h2>Evolutions des besoins</h2>
            <p>
              Le monde du travail est en perpétuel changement, nous en sommes
              convaincus, raison pour laquelle nous vous proposons cette
              solution digitale innovatrice qui s’adaptera à vos besoins dans
              l’ère du temps.
            </p>
          </div>
        </div>
        <div class="col-sm-6 col-md-4">
          <div class="service-item">
            <div class="icon-wrapper">
              <i class="ti-user"> </i>
            </div>
            <h2>Accompagner les candidats</h2>
            <p>
              Accompagner et aider les candidats à mieux s’orienter et
              s’accomplir.
            </p>
            <p>
              Nous prônons une approche novatrice du recrutement, la communion
              de l’humain et du digital pour une parfaite concordance entre le
              candidat et le poste.
            </p>
          </div>
        </div>
        <div class="col-sm-6 col-md-4">
          <div class="service-item">
            <div class="icon-wrapper">
              <i class="ti-home"> </i>
            </div>
            <h2>Assister les entreprises</h2>
            <p>
              Orienter et assister les entreprises dans l’identification et le
              recrutement des talents dont ils ont besoin
            </p>
            <p>
              Conscients de la complexité et des difficultés de recrutement pour
              les entreprises comme pour les candidats, la mise en place d’une
              solution RH adaptée et personnalisée était plus que nécessaire.
              Kira RH est cette solution.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "MainServices",
};
</script>

<style scoped></style>
